function isBrowser(): boolean {
  return typeof window !== "undefined";
}

let storageUnavailableReported = false;

function reportStorageUnavailable(scope: "local" | "session", reason: string): void {
  if (storageUnavailableReported) return;
  storageUnavailableReported = true;
  void import("@sentry/react").then(({ captureMessage, setTag }) => {
    setTag("storage_unavailable", scope);
    captureMessage(`storage_${scope}_unavailable: ${reason}`, "warning");
  }).catch(() => { /* best-effort */ });
}

export function safeLocalStorage(): Storage | null {
  if (!isBrowser()) return null;
  try {
    const ls = window.localStorage;
    if (!ls) {
      reportStorageUnavailable("local", "null");
      return null;
    }
    // Safari Private Browsing throws on first write — probe to detect.
    const probe = "__speak_ls_probe__";
    ls.setItem(probe, "1");
    ls.removeItem(probe);
    return ls;
  } catch (err) {
    reportStorageUnavailable("local", err instanceof Error ? err.name : "unknown");
    return null;
  }
}

export function safeSessionStorage(): Storage | null {
  if (!isBrowser()) return null;
  try {
    const ss = window.sessionStorage;
    if (!ss) {
      reportStorageUnavailable("session", "null");
      return null;
    }
    return ss;
  } catch (err) {
    reportStorageUnavailable("session", err instanceof Error ? err.name : "unknown");
    return null;
  }
}
